<template>
    <div class="BIAnalysis">
        <back :color="1"></back>
    </div>
</template>

<script>
import back from './../back';
export default {
    components: { back },
    props: {},
    data() {
        return {
        };
    },
    watch: {},
    computed: {},
    methods: {},
    created() {},
    mounted() {},
};
</script>
<style lang="stylus" scoped>
.BIAnalysis
    height 100%
    overflow hidden
    background url(./../images/BIAnalysis.png) no-repeat
    background-size 100% 100%
    position relative
</style>